import { basicIntegrations, defaultScmResolveUrl } from '../helpers.esm.js';
import { readAwsS3IntegrationConfigs } from './config.esm.js';

class AwsS3Integration {
  constructor(integrationConfig) {
    this.integrationConfig = integrationConfig;
  }
  static factory = ({ config }) => {
    const configs = readAwsS3IntegrationConfigs(
      config.getOptionalConfigArray("integrations.awsS3") ?? []
    );
    return basicIntegrations(
      configs.map((c) => new AwsS3Integration(c)),
      (i) => i.config.host
    );
  };
  get type() {
    return "awsS3";
  }
  get title() {
    return this.integrationConfig.host;
  }
  get config() {
    return this.integrationConfig;
  }
  resolveUrl(options) {
    const resolved = defaultScmResolveUrl(options);
    return resolved;
  }
  resolveEditUrl(url) {
    return url;
  }
}

export { AwsS3Integration };
//# sourceMappingURL=AwsS3Integration.esm.js.map
